import { css, type Theme } from '@emotion/react';
import { ArrowSquareOut, ChatCircle, ChatsCircle, EnvelopeSimple } from '@phosphor-icons/react';
import { Stack } from 'client/components/Stack';
import { Typography } from 'client/components/Typography';

export const HelpCard = () => (
  <Stack css={cardStyle}>
    <div css={headerStyle}>
      <Typography variant="h6">
        <ChatsCircle size={24} /> Contact Us
      </Typography>
      <Typography variant="body2">
        Issues? Ideas? Feedback? Send us a message! The fastest responses come from our Discord server.
      </Typography>
    </div>
    <Typography component="ul" css={listStyle}>
      <a target="_blank" href="https://discord.gg/vvgQxVjC8G">
        <li>
          <ChatCircle /> Message on Discord <ArrowSquareOut size={14} />
        </li>
      </a>
      <a href="mailto:hello@diploi.com">
        <li>
          <EnvelopeSimple /> Send an Email <ArrowSquareOut size={14} />
        </li>
      </a>
    </Typography>
  </Stack>
);

const cardStyle = (theme: Theme) => css`
  padding: 26px;
  border-radius: ${theme.borderRadius}px;
  border: 2px solid ${theme.color.grey[60]};
  box-sizing: border-box;
`;

const headerStyle = (theme: Theme) => css`
  > h6 {
    display: flex;
    align-items: center;
    gap: 8px;

    > svg {
      opacity: 0.8;
      translate: 0 -2px;
    }
  }
`;

const listStyle = css`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0;
  padding: 0;
  list-style: none;

  a {
    text-decoration: none;
    color: inherit;
  }

  li {
    display: flex;
    align-items: center;
    gap: 4px;
  }
`;
